import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import '../steps/index.css';
var Step = (function (_super) {
    tslib_1.__extends(Step, _super);
    function Step() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Step.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, prefix = _b.prefix, title = _b.title, status = _b.status, isCurrent = _b.isCurrent, isLast = _b.isLast, stepNum = _b.stepNum, others = tslib_1.__rest(_b, ["className", "prefix", "title", "status", "isCurrent", "isLast", "stepNum"]);
        var classes = cn(className, prefix, (_a = {},
            _a[prefix + "-" + status] = status && status !== 'default',
            _a[prefix + "-current"] = isCurrent,
            _a));
        return (React.createElement("div", tslib_1.__assign({ className: classes }, others),
            !isLast && React.createElement("i", { className: prefix + "-tail" }),
            React.createElement("div", { className: prefix + "-num" }, stepNum),
            React.createElement("div", { className: prefix + "-title" }, title)));
    };
    Step.defaultProps = {
        className: '',
        prefix: 'zhui-step',
    };
    return Step;
}(React.Component));
export default Step;
